import { EConstructionProgressActionTypes } from '../../actions/constructionProgressData';
import { IConstructionProgressDataState } from '../../types/constructionProgress';
import { TReduxActions } from '../../types/redux';

export const INITIAL_CONSTRUCTION_PROGRESS_STATE: IConstructionProgressDataState = {
  constructionProgress: [],
  isLast: true,
  isLoading: false,
  totalImagesCount: 0,
  page: 1,
};

export function constructionProgressDataReducer(
  state: IConstructionProgressDataState = INITIAL_CONSTRUCTION_PROGRESS_STATE,
  action: TReduxActions,
): IConstructionProgressDataState {
  switch (action.type) {
    case EConstructionProgressActionTypes.SetNextPage: {
      const { payload } = action;

      return {
        ...state,
        constructionProgress: state.constructionProgress.concat(payload.constructionProgress),
        isLast: payload.isLast,
        isLoading: false,
        page: payload.nextPage,
      };
    }
    case EConstructionProgressActionTypes.SetLoading:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
